'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormInstructionalText = function FormInstructionalText(_ref) {
    var instructionalText = _ref.instructionalText;
    return _react2.default.createElement(
        'div',
        null,
        instructionalText
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(FormInstructionalText);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormInstructionalText.js
// module id = 307
// module chunks = 0